import {
  Box,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import MultiCheckBoxes from "../../../../Components/MultiCheckBox/MultiCheckBoxes";
import MuiButton from "../../../../Components/Button/Button";
import MuiInputField from "../../../../Components/InputField/InputField";
import FileUpload from "../../../../Components/FileUpload/FileUpload";
import CloseIcon from "@mui/icons-material/Close";
import MultiSelectDropDown from "../../../../Components/DropDown/MultiSelectDropDown";
import TextEditor from "../../../../Components/TextEditor/TextEditor";
import DropDown from "../../../../Components/DropDown/DropDown";
import { isEditable } from "@testing-library/user-event/dist/utils";
import { checkNumberLimit, downloadBase64File } from "../../../../Utils/helper";
import docIcon from "../../../../Assets/Hospital/doc.svg";
import { TextView } from "../../../../Components/TextView";
import { DetailChip } from "../../Hospital/DetailTab";
import { EditableList } from "../../../../Components/EditableList";
import { useSearchParams } from "react-router-dom";
import { checkPermission } from "../../../../Utils/Permissions";

export function PersonalDetails(props) {

  const [query] = useSearchParams();
  const from = query.get("from");
  const selectItems = [
    { id: 1, name: "Mykare RMP", value: "MYKARE_RMP" },
    { id: 2, name: "Center RMP", value: "CENTER_RMP" },
  ];


  const urls = props?.details?.referenceLinks?.split(",");
  return (
    <Box
      border={props.isEditable ? "none" : "1px solid lightgrey"}
      borderRadius={2}
      paddingX={5}
      paddingY={5}
    >
      <Grid
        container
        item
        lg={12}
        justifyContent={"center"}
        alignItems={"center"}
      >
        {props.isEditable && (
          <Grid item lg={2}>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                color: "#4c5a6a",
                paddingBottom: "7px",
              }}
            >
              Select Doctor Type
            </Typography>
            <DropDown
              viewWidth={180}
              placeHolder="Doctor Type"
              viewHeight={"40px"}
              borderRadius={"8px"}
              border={"1px solid #DFE5EE"}
              bgColor="#FFFFFF"
              data={selectItems}
              handleSelected={(e, value) => {
                props.setDoctorType(value?.value);
              }}
            />
          </Grid>
        )}


        <Grid
          container
          item
          display={"flex"}
          direction="row"
          lg={12}
          //    justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid item lg={8}>
            <MultiCheckBoxes
              isDisabled={props.isEditable}
              setCheckedItems={props?.setCheckedItems}
              setCheckedItemsId={props?.setCheckedItemsId}
              checkedItems={props?.checkedItems}
              items={props?.items}
            />
          </Grid>
          {(props?.isLive && props?.id) && <Grid item lg={4} >
            <MuiButton
              onClick={props.onDisapprove}
              padding="10px 52px"
              viewHeight="45px"
              bgColor="#17dfba"
              borderRadius="5px"
              title={"Disapprove"}
            />
          </Grid>}
        </Grid>
        {/* <Grid item lg={1.2}>
          {!props.isEditable && (
            <MuiButton
              style={{ position: "absolute", top: "64px" }}
              onClick={() => props.setIsEditable(true)}
              padding="10px 20px"
              viewHeight="30px"
              bgColor={props?.id ? "#17dfba" : "#d5b1ba"}
              borderRadius="100px"
              title={"Edit Details"}
            />
          )}
        </Grid> */}
      </Grid>

      <Grid
        container
        item
        marginTop={"30px"}
        lg={12}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
      >
        <Grid item lg={3.8}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Doctor Name
          </Typography>
          {props.isEditable ? (
            <>
              <MuiInputField
                value={props?.details?.name}
                onChange={(event) => {
                  props?.setDetails((s) => ({
                    ...s,
                    name: event.target.value,
                  }));
                }}
                onBlur={(event) => {
                  if (!event.target.value) {
                    props.setIsDoctorlFieldsValid((s) => ({
                      ...s,
                      isName: true,
                    }));
                  } else {
                    props.setIsDoctorlFieldsValid((s) => ({
                      ...s,
                      isName: false,
                    }));
                  }
                }}
                placeHolder={"Enter the Doctor name"}
              />
              {props.isDoctorlFieldsValid.isName && (
                <Typography fontSize="14px" mt={1} color="red">
                  Doctor name is mandatory
                </Typography>
              )}
              {props.duplicateName && (
                <Typography fontSize="14px" mt={1} color="red">
                  Doctor name already exists
                </Typography>
              )}
            </>
          ) : (
            <TextView>{props?.details?.name}</TextView>
          )}
        </Grid>

        <Grid item lg={3.8}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Medical Counsil Registration Number
          </Typography>
          {props.isEditable ? (
            <MuiInputField
              type="number"
              value={props?.details?.registrationNumber}
              onChange={(event) => {
                props?.setDetails((s) => ({
                  ...s,
                  registrationNumber: event.target.value,
                }));
              }}
              placeHolder={"Add Registration Number"}
            />
          ) : (
            <TextView>{props?.details?.registrationNumber}</TextView>
          )}
        </Grid>
        <Grid item lg={3.8}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Upload Medical Counsil Doc & Others Docs
          </Typography>

          {props.isEditable ? (
            <FileUpload
              id="doctor"
              doc={props?.doc}
              setDoc={props?.setDoc}
              type="doctorDoc"
            />
          ) : (
            <Grid
              sx={{
                display: "flex",
                overflowY: "hidden",
                overflowX: "auto",
                "&::-webkit-scrollbar": {
                  height: "5px",
                  width: "10px",
                  backgroundColor: "lightgray",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "grey",
                  borderRadius: "30px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "grey",
                },
              }}
            >
              {props?.doc?.document?.map((val, i) => {
                return (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "74px",
                      height: "74px",
                      border: "1px solid lightgray",
                      borderRadius: "10px",
                      marginLeft: "10px",
                    }}
                    onClick={() =>
                      downloadBase64File(
                        `data:${val.documentType};base64,${val.document}`,
                        val.documentName
                      )
                    }
                  >
                    <Box
                      component="img"
                      src={docIcon}
                      sx={{
                        width: "60px",
                        height: "60px",
                        objectFit: "contain",
                        ":hover": { transform: "scale(1.5)" },
                        cursor: "pointer",
                      }}
                    />
                  </div>
                );
              })}
            </Grid>
          )}

          {props.isEditable && (
            <EditableList
              onResponseClick={(val, index) => {
                const updatedImages = [...props?.doc.document];
                updatedImages.splice(index, 1);
                props?.setDoc((s) => ({
                  ...s,
                  document: updatedImages,
                  documentIds: [...s.documentIds, val.documentId],
                }));
              }}
              onUploadClick={(val, index) => {
                const updatedImages = [...props?.doc.doctorDoc];
                updatedImages.splice(index, 1);
                props?.setDoc((s) => ({
                  ...s,
                  doctorDoc: updatedImages,
                }));
              }}
              responseDoc={props?.doc?.document}
              uploadDoc={props?.doc?.doctorDoc}
            />
          )}
        </Grid>
      </Grid>
      <Grid
        container
        item
        marginTop={"30px"}
        lg={12}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
      >
        <Grid item lg={3}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Upload Doctor Image
          </Typography>

          {props.isEditable ? (
            <FileUpload
              id="image"
              doc={props.doc}
              setDoc={props.setDoc}
              type="doctorImage"
            />
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "74px",
                height: "74px",
                border: "1px solid lightgray",
                borderRadius: "10px",
                marginLeft: "10px",
              }}
            >
              {props?.doc?.image?.map((val, i) => {
                return (
                  <Grid key={i} height={100} width={100}>
                    <Box
                      component="img"
                      src={`data:${val.documentType};base64,${val.document}`}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </Grid>
                );
              })}
            </div>
          )}

          {props.isEditable && (
            <EditableList
              onResponseClick={(val, index) => {
                const updatedImages = [...props?.doc?.image];
                updatedImages.splice(index, 1);
                props?.setDoc((s) => ({
                  ...s,
                  image: updatedImages,
                  documentIds: [...s.documentIds, val.documentId],
                }));
              }}
              onUploadClick={(val, index) => {
                const updatedImages = [...props?.doc?.doctorImage];
                updatedImages.splice(index, 1);
                props?.setDoc((s) => ({
                  ...s,
                  doctorImage: updatedImages,
                }));
              }}
              responseDoc={props?.doc?.image}
              uploadDoc={props?.doc?.doctorImage}
            />
          )}
        </Grid>

        <Grid item lg={4}>
          <Grid item lg={12}>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                color: "#4c5a6a",
                paddingBottom: "7px",
                paddingTop: "10px",
              }}
            >
              Upload Agreement
            </Typography>
            {props.isEditable ? (
              <FileUpload
                id="agreementDoc"
                doc={props.doc}
                setDoc={props.setDoc}
                type="agreementDoc"
              />
            ) : (
              <Grid
                sx={{
                  display: "flex",
                  overflowY: "hidden",
                  overflowX: "auto",
                  "&::-webkit-scrollbar": {
                    height: "5px",
                    width: "10px",
                    backgroundColor: "lightgray",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "grey",
                    borderRadius: "30px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "grey",
                  },
                }}
              >
                {props.doc?.agreementDocument?.map((val, i) => {
                  return (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "74px",
                        height: "74px",
                        border: "1px solid lightgray",
                        borderRadius: "10px",
                        marginLeft: "10px",
                      }}
                      onClick={() =>
                        downloadBase64File(
                          `data:${val.documentType};base64,${val.document}`,
                          val.documentName
                        )
                      }
                    >
                      <Box
                        component="img"
                        src={docIcon}
                        sx={{
                          width: "60px",
                          height: "60px",
                          objectFit: "contain",
                          ":hover": { transform: "scale(1.5)" },
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  );
                })}
              </Grid>
            )}
            {props.isEditable && (
              <EditableList
                onResponseClick={(val, index) => {
                  const updatedImages = [...props.doc.agreementDocument];
                  updatedImages.splice(index, 1);
                  props.setDoc((s) => ({
                    ...s,
                    agreementDocument: updatedImages,
                    documentIds: [...s.documentIds, val.documentId],
                  }));
                }}
                onUploadClick={(val, index) => {
                  const updatedImages = [...props.doc.agreementDoc];
                  updatedImages.splice(index, 1);
                  props.setDoc((s) => ({
                    ...s,
                    agreementDoc: updatedImages,
                  }));
                }}
                responseDoc={props.doc?.agreementDocument}
                uploadDoc={props.doc?.agreementDoc}
              />
            )}
          </Grid>
        </Grid>
        <Grid item lg={3.8}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Qualification
          </Typography>
          {props.isEditable ? (
            <>
              <MultiSelectDropDown
                handleSelected={(e, value) => {
                  props?.setDetails((s) => ({
                    ...s,
                    qualificationIds: value.map((val) => val.id),
                    qualifications: value.map((val) => val),
                  }));
                }}
                placeholder="Choose Qualification"
                data={props?.qualification}
                value={props?.details?.qualifications}
                onBlur={(e) => {
                  if (
                    !props?.details?.qualifications ||
                    props?.details?.qualifications.length === 0
                  ) {
                    props.setIsDoctorlFieldsValid((s) => ({
                      ...s,
                      qualification: true,
                    }));
                  } else {
                    props.setIsDoctorlFieldsValid((s) => ({
                      ...s,
                      qualification: false,
                    }));
                  }
                }}
              />
              {props.isDoctorlFieldsValid.qualification && (
                <Typography fontSize="14px" mt={1} color="red">
                  Doctor qualification is mandatory
                </Typography>
              )}
            </>
          ) : (
            props?.details?.qualifications.map((val, i) => {
              return <TextView key={i}>{val?.name}</TextView>;
            })
          )}
        </Grid>
        <Grid item lg={3}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Experience
          </Typography>
          {props.isEditable ? (
            <>
              <MuiInputField
                type="number"
                value={props?.details?.startYear}
                onChange={(event) => {
                  props?.setDetails((s) => ({
                    ...s,
                    startYear: event.target.value,
                  }));
                }}
                onBlur={(event) => {
                  if (!event.target.value) {
                    props.setIsDoctorlFieldsValid((s) => ({
                      ...s,
                      experience: true,
                    }));
                  } else {
                    props.setIsDoctorlFieldsValid((s) => ({
                      ...s,
                      experience: false,
                    }));
                  }
                }}
                placeHolder={"Add Experience (Start Year)"}
              />
              {props.isDoctorlFieldsValid.experience && (
                <Typography fontSize="14px" mt={1} color="red">
                  Doctor experience is mandatory
                </Typography>
              )}
            </>
          ) : (
            <TextView>{props?.details?.startYear}</TextView>
          )}
        </Grid>
      </Grid>
      <Grid
        container
        item
        marginTop={"30px"}
        lg={12}
        justifyContent={"space-between"}
        alignItems={"flex-end"}
      >
        <Grid item lg={3}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "20px",
              paddingTop: "20px",
            }}
          >
            Departments
          </Typography>
          {props.isEditable ? (
            <>
              <DropDown
                placeHolder={"Select Department"}
                viewHeight={"44px"}
                borderRadius={"5px"}
                bgColor="white"
                border="2px solid #e9eff7"
                viewWidth="100%"
                value={props?.details?.department}
                data={props?.departments}
                handleSelected={(e, value) => {
                  props?.setDetails((s) => ({
                    ...s,
                    departmentId: value?.id,
                  }));
                  props?.setDetails((s) => ({
                    ...s,
                    department: value,
                  }));
                }}
                onBlur={(event) => {
                  if (!event.target.value) {
                    props.setIsDoctorlFieldsValid((s) => ({
                      ...s,
                      department: true,
                    }));
                  } else {
                    props.setIsDoctorlFieldsValid((s) => ({
                      ...s,
                      department: false,
                    }));
                  }
                }}
              />
              {props.isDoctorlFieldsValid.department && (
                <Typography fontSize="14px" mt={1} color="red">
                  Doctor department is mandatory
                </Typography>
              )}
            </>
          ) : (
            <TextView>{props?.details?.department.name}</TextView>
          )}
        </Grid>
        <Grid item lg={3}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "20px",
              paddingTop: "20px",
            }}
          >
            Working Hospital
          </Typography>
          {props.isEditable ? (
            <>
              <DropDown
                placeHolder={"Select Hospital"}
                viewHeight={"44px"}
                borderRadius={"5px"}
                bgColor="white"
                border="2px solid #e9eff7"
                viewWidth="100%"
                data={props?.hospitals}
                value={props?.details?.hospital}
                handleSelected={(e, value) => {
                  props?.setDetails((s) => ({
                    ...s,
                    centerId: value?.id,
                  }));
                  props?.setDetails((s) => ({
                    ...s,
                    center: value,
                  }));
                }}
                onBlur={(e) => {
                  if (!props.details.center) {
                    props.setIsDoctorlFieldsValid((s) => ({
                      ...s,
                      center: true,
                    }));
                  } else {
                    props.setIsDoctorlFieldsValid((s) => ({
                      ...s,
                      center: false,
                    }));
                  }
                }}
              />

              {props.isDoctorlFieldsValid.center && (
                <Typography fontSize="14px" my={1} color="red">
                  Hospital name is mandatory
                </Typography>
              )}
            </>
          ) : (
            <TextView>{props?.details?.centers?.name}</TextView>
          )}
        </Grid>
        <Grid item sx={{ marginBottom: "10px" }} lg={4}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Contact Number
          </Typography>
          {props.isEditable ? (
            <MuiInputField
              prefix={"+91"}
              type="number"
              value={props?.details?.contactNumber}
              onChange={(event) => {
                const isNumber = checkNumberLimit(event.target.value);
                if (isNumber) {
                  props?.setDetails((s) => ({
                    ...s,
                    contactNumber: event.target.value,
                  }));
                }
              }}
              placeHolder={"Contact Number"}
            />
          ) : (
            <TextView>{"+91 " + props?.details?.contactNumber}</TextView>
          )}
        </Grid>
      </Grid>
      <Grid
        container
        item
        height={"80px"}
        lg={12}
        alignItems={"flex-start"}
        marginTop={"30px"}
        mb={"20px"}
      >
        <Grid item lg={3.8}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Alternate Contact number (Optional)
          </Typography>
          {props.isEditable ? (
            <MuiInputField
              prefix={"+91"}
              type="number"
              value={props?.details?.alternateContactNumber}
              onChange={(event) => {
                const isNumber = checkNumberLimit(event.target.value);
                if (isNumber) {
                  props?.setDetails((s) => ({
                    ...s,
                    alternateContactNumber: event.target.value,
                  }));
                }
              }}
              placeHolder={"add alternate Contact number"}
            />
          ) : (
            props?.details?.alternateContactNumber && (
              <TextView>
                {"+91 " + props?.details?.alternateContactNumber}
              </TextView>
            )
          )}
        </Grid>
        <Grid item lg={3.8} marginLeft={"32px"}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Email
          </Typography>
          {props.isEditable ? (
            <MuiInputField
              value={props?.details?.email}
              onChange={(event) => {
                props?.setDetails((s) => ({
                  ...s,
                  email: event.target.value,
                }));
              }}
              placeHolder={"Add email id"}
            />
          ) : (
            <TextView>{props?.details?.email}</TextView>
          )}
        </Grid>

        <Grid item lg={3} marginLeft={"32px"}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Reference links
          </Typography>
          {props.isEditable ? (
            <MuiInputField
              value={props?.details?.referenceLinks}
              onChange={(event) => {
                props?.setDetails((s) => ({
                  ...s,
                  referralLink: event.target.value,
                }));
              }}
              placeHolder="Add reference Links"
              multiline={true}
              rows={5}
            />
          ) : (
            urls?.map((url, index) => (
              <TextView isUrl={true} href={url} key={index}>
                {url}
              </TextView>
            ))
          )}
        </Grid>
        <Divider />
      </Grid>

      {!props.isEditable && (
        <Box>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "16px",
              color: "#4c5a6a",
              paddingBottom: "7px",
              paddingTop: "30px",
            }}
          >
            Doctor Type
          </Typography>

          <Box
            sx={{
              backgroundColor: "#effef5",
              display: "flex",
              width: "fit-content",
              flexDirection: "row",
              padding: "7px 13px",
              borderRadius: "30px",
              border: "1px solid #65dec7",
              marginX: "10px",
              alignItems: "center",
            }}
          >
            <Box />
            <TextView style={{ fontSize: "14px" }}>
              {props?.details?.doctorType || "Not found"}
            </TextView>
          </Box>
        </Box>
      )}

      <Typography
        sx={{
          fontWeight: "600",
          fontSize: "16px",
          color: "#4c5a6a",
          paddingBottom: "7px",
          paddingTop: "30px",
        }}
      >
        About Doctor
      </Typography>

      <Grid
        sx={{
          width: "100%",
          minHeight: props.isEditable ? 300 : "auto",

          backgroundColor: props.isEditable ? "white" : "transparent",
          marginTop: "30px",
          border: props.isEditable ? "1px solid #e9eff7" : "none",
          borderRadius: "10px",
          marginBottom: "50px",
        }}
      >
        {props.isEditable ? (
          <TextEditor
            initialValue={props?.details?.about}
            onSave={(textValue) => {
              console.log("Text value:", textValue);
              props?.setDetails((s) => ({
                ...s,
                about: textValue,
              }));
            }}
          />
        ) : (
          <TextView>{props?.details?.about}</TextView>
        )}
      </Grid>
      <Divider />
      <Grid item lg={12}>
        <Typography
          sx={{
            fontWeight: "600",
            fontSize: "14px",
            color: "#4c5a6a",
            paddingBottom: "7px",
          }}
        >
          Key Specialisations
        </Typography>
        {props.isEditable ? (
          <MultiSelectDropDown
            handleSelected={(e, value) => {
              props?.setDetails((s) => ({
                ...s,
                specialisationIds: value.map((val) => val.id),
              }));
              props?.setDetails((s) => ({
                ...s,

                specialities: value.map((val) => val),
              }));
            }}
            placeholder="Choose Specialisation"
            data={props?.specialization}
            value={props.details.specialities}
          />
        ) : (
          <Grid sm={12} container item>
            {props?.details?.specialities?.map((val) => {
              return <DetailChip value={val?.name}></DetailChip>;
            })}
          </Grid>
        )}
      </Grid>
      <Grid container lg={12} marginY={"20px"} justifyContent={"flex-end"}>
        {props.isEditable && (
          <Grid lg={0.9}>
            <MuiButton
              onClick={props.onSave}
              padding="10px 30px"
              viewHeight="45px"
              bgColor="#17dfba"
              borderRadius="5px"
              title={"Save"}
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
